import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

import { env } from '../../common/lib/env';

import { useApiRequest } from './useApiRequest';

interface DownloadingAttachment {
  inboundEmailId: string;
  index: number;
}

export function useInboundEmailAttachmentDownload() {
  const request = useApiRequest();
  const [downloading, setDownloading] = useState<DownloadingAttachment | null>(null);

  const downloadAttachment = useCallback(async(inboundEmailId: string, index: number, name: string) => {
    setDownloading({ inboundEmailId, index });

    try {
      const result = await request({
        method: `GET`,
        responseType: `blob`,
        url: `${env.baseApiUrl}communications/inbound-email/${encodeURIComponent(inboundEmailId)}/attachments/${index}/download`,
      });

      const blobUrl = window.URL.createObjectURL(new Blob([result.data]));
      const link = document.createElement(`a`);
      link.href = blobUrl;
      link.setAttribute(`download`, name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    }
    catch {
      toast.error(`Could not download attachment.`);
    }
    finally {
      setDownloading(null);
    }
  }, [request]);

  return {
    downloadAttachment,
    downloading,
  };
}
